import React, { useEffect } from 'react'
import { Grid } from '@mui/material'
import { object, string } from 'yup'
import { Navigate } from 'react-router-dom'

import { PageTitle, FadeInWrapper } from '../components'
import { APP_ROUTES } from '../constants.ts'
import { useResetPasswordMutation } from '../services'
import {
  Form,
  FormSchema,
  FormSchemaMessages,
  FormSchemaTests,
  SubmitButton,
  SubmitErrorMessage,
  TextFieldControl,
} from '../components/form'
import { useAppDispatch } from '@/stores/hooks.ts'
import { userActions } from '@/stores/slices/user-slice.ts'

export interface ResetPasswordFormState {
  login: string
}

const resetPasswordValidationSchema = object<FormSchema<ResetPasswordFormState>>({
  login: string().required(FormSchemaMessages.required).test(FormSchemaTests.isEmail),
})

export const RestorePasswordPage = (): React.ReactElement => {
  const dispatch = useAppDispatch()
  const { mutateAsync, isError, error, isSuccess } = useResetPasswordMutation()

  useEffect(() => {
    if (isError) {
      dispatch(userActions.setLogin(''))
    }
  }, [isError])

  const handleReset = async (formValues: ResetPasswordFormState) => {
    try {
      await mutateAsync(formValues)
      dispatch(userActions.setLogin(formValues.login))
    } catch (e) {
      // используем mutateAsync чтобы отображался лоадер на кнопке
    }
  }

  if (isSuccess) {
    return <Navigate to={APP_ROUTES.ChangePassword} />
  }

  return (
    <FadeInWrapper>
      <PageTitle
        backUrl={APP_ROUTES.Login}
        title="Забыли пароль?"
        description="Введите электронную почту, указанную при регистрации, чтобы сбросить пароль. Мы пришлем инструкцию на указанный адрес"
      />
      <Form name="resetPassword" onSubmit={handleReset} validationSchema={resetPasswordValidationSchema}>
        <Grid container spacing={{ xs: 4, lg: 6 }}>
          <Grid item xs={12}>
            <TextFieldControl name="login" fullWidth label="Ваш email" />
          </Grid>
          <Grid item xs={12}>
            <SubmitErrorMessage message={error?.response?.data.errorMessage} isError={isError} />
            <SubmitButton>Сбросить пароль</SubmitButton>
          </Grid>
        </Grid>
      </Form>
    </FadeInWrapper>
  )
}
